export const mainActionTypes = {
    // CANVAS STARTED
    MAIN_CANVAS_STARTED: 'M63',

    // FETCH DIAGRAM
    MAIN_FETCH_DIAGRAM_REQUEST: 'M64',
    MAIN_FETCH_DIAGRAM_SUCCESS: 'M65',
    MAIN_FETCH_DIAGRAM_FAILURE: 'M66',

    // CLEAR DIAGRAM ERRORS (NOT FOUND) ON FETCH DIAGRAM
    MAIN_CLEAR_DIAGRAM_ERRORS: 'M19',

    // MODAL DIAGRAM DETAILS
    TOGGLE_MODAL_DIAGRAM_DETAILS: 'M49',

    // DIAGRAM RENAME
    MAIN_DIAGRAM_RENAME_REQUEST: 'M8',

    // MODAL FEEDBACK / SUPPORT
    TOGGLE_MODAL_SUPPORT: 'M51',
    SUPPORT_REQ_REQUEST: 'M52',
    SUPPORT_REQ_SUCCESS: 'M53',
    SUPPORT_REQ_FAILURE: 'M54',
    MAIN_CLEAR_FEEDBACK_SENT_STATUS: 'M55',

    // MODAL FEEDBACK THANKS
    TOGGLE_MODAL_FEEDBACK_THANKS: 'M56',

    // MODAL DIAGRAM QUICK SHARE
    TOGGLE_MODAL_DIAGRAM_QUICK_SHARE: 'M73',
    DISABLE_MODAL_DIAGRAM_QUICK_SHARE: 'M74',

    LOAD_NEW_PROJECT: 'M75',
    LOAD_SAMPLE_PROJECT_DETAILS: 'M76',

    TOGGLE_MODAL_DIAGRAM_CREATE_NEW: 'M77',
    ADD_NEW_DIAGRAM: 'M78',

    TOGGLE_MODAL_LANGUAGES: 'M79',
    SET_LANGUAGE: 'M80',

    LOAD_QUICK_SHARE_PROJECT: 'M81',
    HANDLE_QUICK_SHARE_ERROR: 'M82',
};











// export const mainActionTypes = {
//     // FETCH DIAGRAMS LIST
//     MAIN_FETCH_DIAGRAMS_LIST_REQUEST: 'MAIN_FETCH_DIAGRAMS_LIST_REQUEST',
//     MAIN_FETCH_DIAGRAMS_LIST_SUCCESS: 'MAIN_FETCH_DIAGRAMS_LIST_SUCCESS',
//     MAIN_FETCH_DIAGRAMS_LIST_FAILURE: 'MAIN_FETCH_DIAGRAMS_LIST_FAILURE',

//     // FETCH TEMPLATES LIST
//     MAIN_FETCH_TEMPLATES_LIST_REQUEST: 'MAIN_FETCH_TEMPLATES_LIST_REQUEST',
//     MAIN_FETCH_TEMPLATES_LIST_SUCCESS: 'MAIN_FETCH_TEMPLATES_LIST_SUCCESS',
//     MAIN_FETCH_TEMPLATES_LIST_FAILURE: 'MAIN_FETCH_TEMPLATES_LIST_FAILURE',

//     // DIAGRAM RENAME
//     TOGGLE_MODAL_DIAGRAM_RENAME: 'TOGGLE_MODAL_DIAGRAM_RENAME',
//     MAIN_DIAGRAM_RENAME_REQUEST: 'MAIN_DIAGRAM_RENAME_REQUEST',
//     MAIN_DIAGRAM_RENAME_SUCCESS: 'MAIN_DIAGRAM_RENAME_SUCCESS',
//     MAIN_DIAGRAM_RENAME_FAILURE: 'MAIN_DIAGRAM_RENAME_FAILURE',

//     // DIAGRAM CLONE
//     TOGGLE_MODAL_DIAGRAM_CLONE: 'TOGGLE_MODAL_DIAGRAM_CLONE',
//     MAIN_DIAGRAM_CLONE_REQUEST: 'MAIN_DIAGRAM_CLONE_REQUEST',
//     MAIN_DIAGRAM_CLONE_SUCCESS: 'MAIN_DIAGRAM_CLONE_SUCCESS',
//     MAIN_DIAGRAM_CLONE_FAILURE: 'MAIN_DIAGRAM_CLONE_FAILURE',

//     // DIAGRAM SOFT DELETE (ARCHIVE)
//     TOGGLE_MODAL_DIAGRAM_SOFT_DELETE: 'TOGGLE_MODAL_DIAGRAM_SOFT_DELETE',
//     MAIN_DIAGRAM_SOFT_DELETE_REQUEST: 'MAIN_DIAGRAM_SOFT_DELETE_REQUEST',
//     MAIN_DIAGRAM_SOFT_DELETE_SUCCESS: 'MAIN_DIAGRAM_SOFT_DELETE_SUCCESS',
//     MAIN_DIAGRAM_SOFT_DELETE_FAILURE: 'MAIN_DIAGRAM_SOFT_DELETE_FAILURE',

//     MAIN_CLEAR_DIAGRAM_ERRORS: 'MAIN_CLEAR_DIAGRAM_ERRORS',

//     // DIAGRAM DELETE
//     TOGGLE_MODAL_DIAGRAM_DELETE: 'TOGGLE_MODAL_DIAGRAM_DELETE',
//     MAIN_DIAGRAM_DELETE_REQUEST: 'MAIN_DIAGRAM_DELETE_REQUEST',
//     MAIN_DIAGRAM_DELETE_SUCCESS: 'MAIN_DIAGRAM_DELETE_SUCCESS',
//     MAIN_DIAGRAM_DELETE_FAILURE: 'MAIN_DIAGRAM_DELETE_FAILURE',

//     // DIAGRAM RESTORE
//     TOGGLE_MODAL_DIAGRAM_RESTORE: 'TOGGLE_MODAL_DIAGRAM_RESTORE',
//     MAIN_DIAGRAM_RESTORE_REQUEST: 'MAIN_DIAGRAM_RESTORE_REQUEST',
//     MAIN_DIAGRAM_RESTORE_SUCCESS: 'MAIN_DIAGRAM_RESTORE_SUCCESS',
//     MAIN_DIAGRAM_RESTORE_FAILURE: 'MAIN_DIAGRAM_RESTORE_FAILURE',

//     // DIAGRAM SHARE
//     TOGGLE_MODAL_DIAGRAM_SHARE: 'TOGGLE_MODAL_DIAGRAM_SHARE',
//     MAIN_DIAGRAM_SHARE_REQUEST: 'MAIN_DIAGRAM_SHARE_REQUEST',
//     MAIN_DIAGRAM_SHARE_SUCCESS: 'MAIN_DIAGRAM_SHARE_SUCCESS',
//     MAIN_DIAGRAM_SHARE_FAILURE: 'MAIN_DIAGRAM_SHARE_FAILURE',


//     // TEMPLATE CLONE
//     TOGGLE_MODAL_TEMPLATE_CLONE: 'TOGGLE_MODAL_TEMPLATE_CLONE',
//     MAIN_TEMPLATE_CLONE_REQUEST: 'MAIN_TEMPLATE_CLONE_REQUEST',
//     MAIN_TEMPLATE_CLONE_SUCCESS: 'MAIN_TEMPLATE_CLONE_SUCCESS',
//     MAIN_TEMPLATE_CLONE_FAILURE: 'MAIN_TEMPLATE_CLONE_FAILURE',

//     // SIDEBAR
//     TOGGLE_SIDEBAR_COLLAPSE: 'TOGGLE_SIDEBAR_COLLAPSE',
//     TOGGLE_SIDEBAR_PROFILE_MENU: 'TOGGLE_SIDEBAR_PROFILE_MENU',

//     // PRICING PLAN
//     TOGGLE_MODAL_PRICING_PLAN_LIMIT: 'TOGGLE_MODAL_PRICING_PLAN_LIMIT',
//     TOGGLE_MODAL_PRICING_PLAN_UPGRADE: 'TOGGLE_MODAL_PRICING_PLAN_UPGRADE',
//     PRICING_PLAN_UPGRADE_REQUEST: 'PRICING_PLAN_UPGRADE_REQUEST',
//     PRICING_PLAN_UPGRADE_SUCCESS: 'PRICING_PLAN_UPGRADE_SUCCESS',
//     PRICING_PLAN_UPGRADE_FAILURE: 'PRICING_PLAN_UPGRADE_FAILURE',

//     // DIAGRAM CREATE
//     TOGGLE_MODAL_DIAGRAM_CREATE: 'TOGGLE_MODAL_DIAGRAM_CREATE',
//     TOGGLE_MODAL_DIAGRAM_CREATE_EMPTY: 'TOGGLE_MODAL_DIAGRAM_CREATE_EMPTY',
//     DIAGRAM_CREATE_REQUEST: 'DIAGRAM_CREATE_REQUEST',
//     DIAGRAM_CREATE_SUCCESS: 'DIAGRAM_CREATE_SUCCESS',
//     DIAGRAM_CREATE_FAILURE: 'DIAGRAM_CREATE_FAILURE',

//     // DIAGRAM IMPORT SQL
//     TOGGLE_MODAL_DIAGRAM_IMPORT_SQL: 'TOGGLE_MODAL_DIAGRAM_IMPORT_SQL',

//     // DIAGRAM/TEMPLATE DETAILS
//     TOGGLE_MODAL_DIAGRAM_DETAILS: 'TOGGLE_MODAL_DIAGRAM_DETAILS',
//     TOGGLE_MODAL_TEMPLATE_DETAILS: 'TOGGLE_MODAL_TEMPLATE_DETAILS',

//     // SUPPORT
//     TOGGLE_MODAL_SUPPORT: 'TOGGLE_MODAL_SUPPORT',
//     SUPPORT_REQ_REQUEST: 'SUPPORT_REQ_REQUEST',
//     SUPPORT_REQ_SUCCESS: 'SUPPORT_REQ_SUCCESS',
//     SUPPORT_REQ_FAILURE: 'SUPPORT_REQ_FAILURE',
//     MAIN_CLEAR_FEEDBACK_SENT_STATUS: 'MAIN_CLEAR_FEEDBACK_SENT_STATUS',

//     TOGGLE_MODAL_FEEDBACK_THANKS: 'TOGGLE_MODAL_FEEDBACK_THANKS',

//     // INVITE PEOPLE
//     TOGGLE_MODAL_INVITE_PEOPLE: 'TOGGLE_MODAL_INVITE_PEOPLE',
//     INVITE_PEOPLE_REQUEST: 'INVITE_PEOPLE_REQUEST',
//     INVITE_PEOPLE_SUCCESS: 'INVITE_PEOPLE_SUCCESS',
//     INVITE_PEOPLE_FAILURE: 'INVITE_PEOPLE_FAILURE',
//     MAIN_CLEAR_INVITE_SENT_STATUS: 'MAIN_CLEAR_INVITE_SENT_STATUS',

//     MOVE_TO_CANVAS: 'MOVE_TO_CANVAS',
//     MAIN_CANVAS_STARTED: 'MAIN_CANVAS_STARTED',

//     MAIN_FETCH_DIAGRAM_REQUEST: 'MAIN_FETCH_DIAGRAM_REQUEST',
//     MAIN_FETCH_DIAGRAM_SUCCESS: 'MAIN_FETCH_DIAGRAM_SUCCESS',
//     MAIN_FETCH_DIAGRAM_FAILURE: 'MAIN_FETCH_DIAGRAM_FAILURE',

//    MODAL DIAGRAM QUICK SHARE
//    TOGGLE_MODAL_DIAGRAM_QUICK_SHARE: 'TOGGLE_MODAL_DIAGRAM_QUICK_SHARE',
//    DISABLE_MODAL_DIAGRAM_QUICK_SHARE: 'DISABLE_MODAL_DIAGRAM_QUICK_SHARE',

//    LOAD_NEW_PROJECT: 'LOAD_NEW_PROJECT',
//    LOAD_SAMPLE_PROJECT_DETAILS: 'LOAD_SAMPLE_PROJECT_DETAILS',

//    TOGGLE_MODAL_DIAGRAM_CREATE_NEW: 'TOGGLE_MODAL_DIAGRAM_CREATE_NEW',
//    ADD_NEW_DIAGRAM: 'ADD_NEW_DIAGRAM',

//    TOGGLE_MODAL_LANGUAGES: 'TOGGLE_MODAL_LANGUAGES',
//    SET_LANGUAGE: 'SET_LANGUAGE',

//    LOAD_QUICK_SHARE_PROJECT: 'LOAD_QUICK_SHARE_PROJECT',
//    HANDLE_QUICK_SHARE_ERROR: 'HANDLE_QUICK_SHARE_ERROR',
// };
